@if (state$ | async; as state) {
  <div class="page-header">
    <div class="page-title">Produkcja</div>

    <div class="header-toggles">
      <div class="view-toggle" [class.hidden]="state.viewMode === 'byOrder'">
        <button
          class="view-toggle-btn"
          [class.active]="state.workFilter === 'ready'"
          (click)="setWorkFilter('ready')">Do zrobienia</button>
        <button
          class="view-toggle-btn"
          [class.active]="state.workFilter === 'all'"
          (click)="setWorkFilter('all')">Wszystko</button>
      </div>

      <div class="view-toggle">
        <button
          class="view-toggle-btn"
          [class.active]="state.viewMode === 'byOperation'"
          (click)="setViewMode('byOperation')">Wg etapów</button>
        <button
          class="view-toggle-btn"
          [class.active]="state.viewMode === 'byItem'"
          (click)="setViewMode('byItem')">Wg pozycji</button>
        <button
          class="view-toggle-btn"
          [class.active]="state.viewMode === 'byOrder'"
          (click)="setViewMode('byOrder')">Wg zleceń</button>
      </div>
    </div>
  </div>

  @if (state.loading) {
    <div class="overseer-body">Ładowanie…</div>
  } @else {
    <div class="summary">
      <div class="summary-card">
        <div class="summary-label">Zlecenia w toku</div>
        <div class="summary-value text-mono">{{ state.summary.ordersInProgress }}</div>
      </div>
      <div class="summary-card">
        <div class="summary-label">Po terminie</div>
        <div class="summary-value text-mono" [class.overdue]="state.summary.ordersOverdue > 0">{{ state.summary.ordersOverdue }}</div>
      </div>
      <div class="summary-card">
        <div class="summary-label">Termin w tym tygodniu</div>
        <div class="summary-value text-mono">{{ state.summary.ordersDueThisWeek }}</div>
      </div>
    </div>

    @if (state.headerMenu) {
      <context-menu [items]="headerMenuItems(state)" [openAt]="state.headerMenu.position"
        (actionSelected)="onHeaderMenuAction($event)" (closed)="onHeaderMenuClose()"></context-menu>
    }

    @if (state.treeMenu) {
      <context-menu [items]="treeMenuItems(state)" [openAt]="state.treeMenu.position"
        (actionSelected)="onTreeMenuAction($event)" (closed)="onTreeMenuClose()"></context-menu>
    }

    <!-- Zgłoś from a node's menu (0102): the one report form, floating where the menu was -->
    @if (state.reportTarget?.openAt; as openAt) {
      <div class="report-popover" [style.left.px]="openAt.x" [style.top.px]="openAt.y" (clickOutside)="cancelReport($event)">
        <div class="report-popover-caption" [title]="reportPopoverCaption(state)">{{ reportPopoverCaption(state) }}</div>
        <ng-container *ngTemplateOutlet="reportForm; context: { target: state.reportTarget }"></ng-container>
      </div>
    }

    @let stage = selectedStage(state);

    <!-- The sheet, and under Wg etapów the DRZEWO card beside it, share the rest of the viewport (0098) -->
    <div class="overseer-body" [class.with-tree]="state.viewMode === 'byOperation'">
      <div class="work-table" #workTable>
        <!-- The head stays put while the rows scroll under it -->
        <div class="table-head">
          @if (state.viewMode === 'byOperation') {
            <!-- The stage strip: the dictionary's UI in this mode, one tab per stage in plant order -->
            <div class="stage-strip">
              @if (state.operationTypes.length === 0 && !state.headerEdit) {
                <ng-container *ngTemplateOutlet="headerHint"></ng-container>
              }

              @for (operationType of state.operationTypes; track operationType.id; let i = $index) {
                @if (isInsertAt(state, i)) {
                  <ng-container *ngTemplateOutlet="headerInput; context: { value: '' }"></ng-container>
                }

                @if (isRenaming(state, operationType.id)) {
                  <ng-container *ngTemplateOutlet="headerInput; context: { value: operationType.name }"></ng-container>
                } @else {
                  <button class="stage-tab" [class.active]="operationType.id === stage?.id" [title]="headerTitle(operationType)"
                    (click)="selectStage(operationType.id)"
                    (contextmenu)="onHeaderContextMenu($event, operationType)">
                    {{ operationType.name }}
                    @if (state.stageCounts[operationType.id]; as count) {
                      <span class="stage-count text-mono">{{ count }}</span>
                    }
                  </button>
                }
              }

              @if (isInsertAt(state, state.operationTypes.length)) {
                <ng-container *ngTemplateOutlet="headerInput; context: { value: '' }"></ng-container>
              }

              <button class="btn btn-small btn-ghost" (click)="startAddOperation(state)">+ etap</button>

              @if (state.headerEditError) {
                <span class="header-error">{{ state.headerEditError }}</span>
              }
            </div>

            @if (stage) {
              <div class="header-row">
                <div class="row-main"></div>
                <div class="op-cell op-header">Czeka</div>
                <div class="row-amount op-header stage-name" [title]="stage.name">{{ stage.name }}</div>
              </div>
            }
          } @else {
            <div class="header-row">
              <div class="row-main header-add">
                @if (state.headerEditError) {
                  <span class="header-error">{{ state.headerEditError }}</span>
                }
                <button class="btn btn-small btn-ghost" (click)="startAddOperation(state)">+ etap</button>
              </div>

              @if (state.operationTypes.length === 0 && !state.headerEdit) {
                <ng-container *ngTemplateOutlet="headerHint"></ng-container>
              }

              @for (operationType of state.operationTypes; track operationType.id; let i = $index) {
                @if (isInsertAt(state, i)) {
                  <ng-container *ngTemplateOutlet="headerInput; context: { value: '' }"></ng-container>
                }

                @if (isRenaming(state, operationType.id)) {
                  <ng-container *ngTemplateOutlet="headerInput; context: { value: operationType.name }"></ng-container>
                } @else {
                  <div class="op-cell op-header" [title]="headerTitle(operationType)"
                    (contextmenu)="onHeaderContextMenu($event, operationType)">{{ operationType.name }}</div>
                }
              }

              @if (isInsertAt(state, state.operationTypes.length)) {
                <ng-container *ngTemplateOutlet="headerInput; context: { value: '' }"></ng-container>
              }

              <div class="row-amount op-header">Gotowe</div>
            </div>
          }
        </div>

        @if (state.viewMode === 'byItem') {
          @for (group of state.itemGroups; track group.bomItemId) {
            <div class="item-row" [class.row-done]="group.isDone" [class.row-blocked]="group.isBlocked" (click)="toggleItem(group.bomItemId)">
              <div class="row-chevron" [class.expanded]="isExpanded(state, group.bomItemId)">›</div>
              <item-photo [attachmentId]="group.primaryPhotoAttachmentId" [label]="group.itemName"></item-photo>

              <div class="row-main">
                <div class="item-name-line">
                  <div class="item-name" [class.done-strike]="group.isDone" [title]="group.itemName">{{ group.itemName }}</div>
                  <span class="structure-tag">{{ structureLabels[group.structure] }}</span>
                </div>
                <div class="item-meta">{{ group.metaLabel }}</div>
                @if (group.blockedByLabel) {
                  <div class="item-meta blocked-label">{{ group.blockedByLabel }}</div>
                }
              </div>

              @if (group.workableLabel) {
                <div class="workable-chip">{{ group.workableLabel }}</div>
              }

              @if (group.hasDocumentation) {
                <ng-container *ngTemplateOutlet="docIcon"></ng-container>
              }

              @if (group.deadline) {
                <div class="deadline-chip"
                  [class.chip-overdue]="group.deadline.urgency === 'overdue'"
                  [class.chip-soon]="group.deadline.urgency === 'soon'">{{ group.deadline.label }}</div>
              } @else {
                <div class="done-check">✓ gotowe</div>
              }

              @for (cell of group.operations; track cell.operationTypeId) {
                @if (isCellOpen(group, cell)) {
                  <div class="op-cell text-mono clickable"
                    [class.targeted]="isItemCellTarget(state, group.bomItemId, cell.operationTypeId)"
                    [class.cell-skipped]="cell.isSkipped"
                    [attr.title]="cell.lastReportedLabel"
                    (click)="startItemReport(group, cell, $event)">{{ cellLabel(cell) }}</div>
                } @else {
                  <div class="op-cell text-mono" [class.cell-done]="cell.isDone" [class.cell-skipped]="cell.isSkipped"
                    [attr.title]="cell.lastReportedLabel">{{ cellLabel(cell) }}</div>
                }
              }

              <div class="row-amount text-mono">{{ formatNumber(group.doneTotal) }} / {{ formatAmount(group.requiredTotal, group.unit) }}</div>

              @if (itemReportTarget(state, group.bomItemId); as target) {
                <ng-container *ngTemplateOutlet="reportForm; context: { target: target }"></ng-container>
              } @else if (!group.isDone) {
                <button class="btn" (click)="startItemReport(group, null, $event)">Zgłoś</button>
              }
            </div>

            @if (isExpanded(state, group.bomItemId)) {
              @for (line of group.lines; track line.lineId) {
                <div class="line-row line-row-grouped" [class.row-done]="line.isDone" [class.row-blocked]="line.isBlocked">
                  <div class="row-main">
                    <span class="line-order" [class.done-strike]="line.isDone">Zlec. {{ line.orderNumber }}</span>
                    <span class="line-parent" [attr.title]="line.parentName">
                      ·
                      @if (line.parentName) {
                        do: {{ line.parentName }}
                      } @else {
                        produkt końcowy
                      }
                    </span>
                    @if (line.blockedByLabel) {
                      <span class="line-parent blocked-label">· {{ line.blockedByLabel }}</span>
                    } @else if (line.workableLabel) {
                      <span class="line-parent workable-label">· {{ line.workableLabel }}</span>
                    }
                  </div>

                  <div class="line-deadline text-mono" [class.overdue]="line.isOverdue && !line.isDone">{{ line.deadlineLabel }}</div>

                  @for (cell of line.operations; track cell.operationTypeId) {
                    @if (isCellOpen(line, cell)) {
                      <div class="op-cell text-mono clickable"
                        [class.targeted]="isLineCellTarget(state, line.lineId, cell.operationTypeId)"
                        [class.cell-skipped]="cell.isSkipped"
                        [attr.title]="cell.lastReportedLabel"
                        (click)="startLineReport(line, cell, $event)">{{ cellLabel(cell) }}</div>
                    } @else {
                      <div class="op-cell text-mono" [class.cell-done]="cell.isDone" [class.cell-skipped]="cell.isSkipped"
                        [attr.title]="cell.lastReportedLabel">{{ cellLabel(cell) }}</div>
                    }
                  }

                  <div class="row-amount text-mono">
                    @if (line.isDone) {
                      <span class="done-check">✓</span>
                    }
                    {{ formatNumber(line.doneAmount) }} / {{ formatAmount(line.requiredAmount, line.unit) }}
                  </div>

                  @if (lineReportTarget(state, line.lineId); as target) {
                    <ng-container *ngTemplateOutlet="reportForm; context: { target: target }"></ng-container>
                  } @else if (!line.isDone) {
                    <button class="btn btn-small" (click)="startLineReport(line, null, $event)">Zgłoś</button>
                  }
                </div>
              }
            }

            @if (state.lastReport && state.lastReport.bomItemId === group.bomItemId) {
              <div class="report-confirmation">
                <span class="report-confirmation-check">✓</span>
                <span class="report-confirmation-message">{{ state.lastReport.message }}</span>
                <button class="btn btn-small" (click)="undoLastReport()">Cofnij</button>
              </div>
            }
          }
        } @else if (state.viewMode === 'byOperation') {
          @for (group of state.stageGroups; track group.key) {
            <!-- A zlecenie's block reads as its tree (0108): 20 px further in per level, DRZEWO's step -->
            <div class="item-row"
              [class.row-done]="group.state === 'passed'"
              [class.row-blocked]="group.state === 'notArrived' || group.state === 'skipped'"
              [class.row-focused]="isStageGroupFocused(state, group.key)"
              [style.padding-left.px]="10 + group.depth * 20"
              [attr.data-row-key]="group.key"
              (click)="toggleStageGroup(group.key)">
              <div class="row-chevron" [class.expanded]="isStageGroupExpanded(state, group.key)">›</div>
              <item-photo [attachmentId]="group.primaryPhotoAttachmentId" [label]="group.itemName"></item-photo>

              <div class="row-main">
                <div class="item-name-line">
                  <div class="item-name" [class.done-strike]="group.isDone" [title]="group.itemName">{{ group.itemName }}</div>
                  <span class="structure-tag">{{ structureLabels[group.structure] }}</span>
                </div>
                <div class="item-meta">{{ group.metaLabel }}</div>
              </div>

              @if (group.hasDocumentation) {
                <ng-container *ngTemplateOutlet="docIcon"></ng-container>
              }

              @if (group.deadline) {
                <div class="deadline-chip"
                  [class.chip-overdue]="group.deadline.urgency === 'overdue'"
                  [class.chip-soon]="group.deadline.urgency === 'soon'">{{ group.deadline.label }}</div>
              } @else {
                <div class="done-check">✓ gotowe</div>
              }

              <div class="op-cell text-mono">{{ group.waitingTotal ? formatNumber(group.waitingTotal) : '' }}</div>

              <div class="row-amount text-mono">{{ formatNumber(group.doneAtStageTotal) }} / {{ formatAmount(group.requiredTotal, group.unit) }}</div>

              @if (stageGroupReportTarget(state, group.key); as target) {
                <ng-container *ngTemplateOutlet="reportForm; context: { target: target }"></ng-container>
              } @else if (group.state === 'skipped') {
                <button class="btn" (click)="restoreStageGroup(group, $event)">Przywróć</button>
              } @else {
                <!-- status · actions: Nic do zrobienia is an action that changes the queue, so it
                     is a bordered button after Zgłoś, not a muted word in the status column (0115) -->
                @if (!group.isDone && group.remainingAtStageTotal > 0) {
                  <button class="btn" (click)="startStageGroupReport(group, $event)">Zgłoś</button>
                }
                @if (group.canSkip) {
                  <button class="btn btn-small btn-secondary" (click)="skipStageGroup(group, $event)">Nic do zrobienia</button>
                }
              }
            </div>

            @if (isStageGroupExpanded(state, group.key)) {
              @for (line of group.lines; track line.lineId) {
                <!-- the group's lines keep lining up with its name: the same shift as the row above -->
                <div class="line-row line-row-grouped"
                  [class.row-done]="line.state === 'passed'"
                  [class.row-blocked]="line.state === 'notArrived' || line.state === 'skipped'"
                  [class.row-focused]="isStageLineFocused(state, line.lineId)"
                  [style.padding-left.px]="72 + group.depth * 20"
                  [attr.data-line-id]="line.lineId"
                  (click)="focusStageLine(group, line)">
                  <div class="row-main">
                    <span class="line-order" [class.done-strike]="line.isDone">Zlec. {{ line.orderNumber }}</span>
                    @if (line.metaLabel) {
                      <span class="line-parent">· {{ line.metaLabel }}</span>
                    }
                  </div>

                  <div class="line-deadline text-mono" [class.overdue]="line.isOverdue && !line.isDone">{{ line.deadlineLabel }}</div>

                  <div class="op-cell text-mono">{{ line.waiting ? formatNumber(line.waiting) : '' }}</div>

                  <div class="row-amount text-mono">{{ formatNumber(line.doneAtStage) }} / {{ formatAmount(line.requiredAmount, line.unit) }}</div>

                  @if (lineReportTarget(state, line.lineId); as target) {
                    <ng-container *ngTemplateOutlet="reportForm; context: { target: target }"></ng-container>
                  } @else if (line.state === 'skipped') {
                    <button class="btn btn-small" (click)="restoreStageLine(group, line, $event)">Przywróć</button>
                  } @else {
                    @if (!line.isDone && line.remainingAtStage > 0) {
                      <button class="btn btn-small" (click)="startStageLineReport(group, line, $event)">Zgłoś</button>
                    }
                    @if (line.canSkip) {
                      <button class="btn btn-small btn-secondary" (click)="skipStageLine(group, line, $event)">Nic do zrobienia</button>
                    }
                  }
                </div>
              }
            }

            @if (state.lastReport && state.lastReport.groupKey === group.key) {
              <div class="report-confirmation">
                <span class="report-confirmation-check">✓</span>
                <span class="report-confirmation-message">{{ state.lastReport.message }}</span>
                <button class="btn btn-small" (click)="undoLastReport()">Cofnij</button>
              </div>
            }
          } @empty {
            @if (stage && state.workFilter === 'ready') {
              <div class="empty-row">Nic nie czeka na ten etap.</div>
            }
          }
        } @else {
          @for (group of state.orderGroups; track group.orderId) {
            <div class="order-header-row">
              <div class="row-main">
                <span class="order-title" [title]="group.orderName">Zlecenie {{ group.orderNumber }} — {{ group.orderName }}</span>
              </div>

              <div class="deadline-chip"
                [class.chip-overdue]="group.deadline.urgency === 'overdue' && !group.isDone"
                [class.chip-soon]="group.deadline.urgency === 'soon' && !group.isDone">{{ group.deadline.label }}</div>

              <div class="order-line-count text-mono">{{ group.doneLineCount }} / {{ group.lineCount }} elem.</div>

              <div class="progress-bar">
                <div class="progress-bar-fill" [style.width.%]="group.progressPercent"></div>
              </div>
            </div>

            @for (line of group.lines; track line.lineId) {
              <!-- the exact tree under every zlecenie header (0108): each line 20 px per level further in -->
              <div class="line-row line-row-order" [class.row-done]="line.isDone" [class.row-blocked]="line.isBlocked"
                [style.padding-left.px]="34 + line.depth * 20">
                <item-photo [attachmentId]="line.primaryPhotoAttachmentId" [label]="line.itemName"></item-photo>
                <div class="row-main">
                  <span class="line-item-name" [class.done-strike]="line.isDone" [title]="line.itemName">{{ line.itemName }}</span>
                  <span class="structure-tag">{{ structureLabels[line.structure] }}</span>
                  <span class="line-parent" [attr.title]="line.parentName">
                    ·
                    @if (line.parentName) {
                      do: {{ line.parentName }}
                    } @else {
                      produkt końcowy
                    }
                  </span>
                  @if (line.blockedByLabel) {
                    <span class="line-parent blocked-label">· {{ line.blockedByLabel }}</span>
                  } @else if (line.workableLabel) {
                    <span class="line-parent workable-label">· {{ line.workableLabel }}</span>
                  }
                </div>

                @for (cell of line.operations; track cell.operationTypeId) {
                  @if (isCellOpen(line, cell)) {
                    <div class="op-cell text-mono clickable"
                      [class.targeted]="isLineCellTarget(state, line.lineId, cell.operationTypeId)"
                      [class.cell-skipped]="cell.isSkipped"
                      [attr.title]="cell.lastReportedLabel"
                      (click)="startLineReport(line, cell, $event)">{{ cellLabel(cell) }}</div>
                  } @else {
                    <div class="op-cell text-mono" [class.cell-done]="cell.isDone" [class.cell-skipped]="cell.isSkipped"
                      [attr.title]="cell.lastReportedLabel">{{ cellLabel(cell) }}</div>
                  }
                }

                <div class="row-amount text-mono">
                  @if (line.isDone) {
                    <span class="done-check">✓</span>
                  }
                  {{ formatNumber(line.doneAmount) }} / {{ formatAmount(line.requiredAmount, line.unit) }}
                </div>

                @if (lineReportTarget(state, line.lineId); as target) {
                  <ng-container *ngTemplateOutlet="reportForm; context: { target: target }"></ng-container>
                } @else if (!line.isDone) {
                  <button class="btn btn-small" (click)="startLineReport(line, null, $event)">Zgłoś</button>
                }
              </div>
            }
          }
        }
      </div>

      @if (state.viewMode === 'byOperation') {
        <!-- DRZEWO: the focused row in its zlecenie tree, each node marked at the selected stage (0098) -->
        <div class="card tree-card">
          <div class="card-header">
            DRZEWO
            @if (state.contextTree; as tree) {
              <div class="card-header-scope text-mono" [title]="tree.orderName">
                Zlec. {{ tree.orderNumber }}
                @if (tree.orderCount > 1) {
                  · 1 z {{ tree.orderCount }}
                }
              </div>
            }
          </div>

          @if (state.contextTree; as tree) {
            <context-tree-node [node]="tree.root" (nodeClicked)="focusTreeNode($event)" (nodeMenuRequested)="onTreeContextMenu($event)"></context-tree-node>
          } @else {
            <div class="tree-empty">Kliknij wiersz, żeby zobaczyć, gdzie siedzi w zleceniu.</div>
          }
        </div>
      }
    </div>

    <!-- The one report form, rendered in the row that opened it -->
    <ng-template #reportForm let-target="target">
      <div class="report-form" (click)="stop($event)">
        <input class="report-input text-mono" type="text" inputmode="decimal"
          [value]="target.prefill > 0 ? formatAmountInput(target.prefill) : ''" #reportAmount
          (keydown.enter)="confirmReport(reportAmount.value, $event)"
          (keydown.escape)="cancelReport($event)">
        @if (target.operationTypeId != null) {
          <label class="report-check">
            <input type="checkbox" [checked]="target.completesItem" (change)="toggleCompletesItem()">
            gotowe
          </label>
        }
        <button class="btn" (click)="confirmReport(reportAmount.value, $event)">OK</button>
        <button class="btn btn-ghost" (click)="cancelReport($event)">✕</button>
      </div>
    </ng-template>

    <ng-template #docIcon>
      <div class="doc-icon" title="Dokumentacja">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
        </svg>
      </div>
    </ng-template>

    <!-- First-time hint: sits where the columns (or the tabs) will be, gone with the first entry -->
    <ng-template #headerHint>
      <div class="header-hint">Dodaj etapy produkcji (np. Cięcie, Gięcie, Malowanie) — każdy etap to kolumna, w którą zgłaszasz postęp.</div>
    </ng-template>

    <!-- The one header input, rendered in the slot the column lands in (or the column being renamed) -->
    <ng-template #headerInput let-value="value">
      <div class="op-cell op-header op-edit" (click)="stop($event)">
        <input class="search-input header-input" type="text" placeholder="Nazwa etapu" [value]="value" #headerEditInput
          (keydown.enter)="submitHeaderEdit(headerEditInput.value, $event)"
          (keydown.escape)="cancelHeaderEdit($event)">
        <button class="btn btn-small btn-ghost" (click)="cancelHeaderEdit($event)">✕</button>
      </div>
    </ng-template>
  }
}
